import { ILoanDetail } from '@/types'

export interface LoanSlice {
  selectedLoan: ILoanDetail
  setSelectedLoan: (loan: ILoanDetail) => void
}
 
export const createLoanSlice = (set: any): LoanSlice => ({
  selectedLoan: {} as ILoanDetail,
  setSelectedLoan: (loan: ILoanDetail) => set({ selectedLoan: loan }),
})
